import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const GoogleAnalyticsWrapper = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.initialize("G-0R7CRD5VLC");
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);
  return <div>{children}</div>;
};

export default GoogleAnalyticsWrapper;
